<div class="main-label-wrapper" [ngStyle]="mainLabelStyle">
  <b>{{element.attributes['mainLabel'] | translate}}</b>
</div>
<div class="form-row-wrapper">
  <div class="form-element right-margin" [ngStyle]="doubleFormElementStyle">
    <app-fb-input
      [formGroup]="paymentForm"
      [prefix]="phonePrefix$ | async"
      name="phone"
      [label]="element.attributes['subLabel']"
      [placeholder]="phonePlaceholder$ | async"
      errorMassage="Phone"
      type="tel"
      [mask]="phoneMask$ | async"
      [inputBackground]="template.inputBackground"
      [color]="template.fontColor"
      [fontFamily]="template.fontFamily"
      [fontSize]="template.fontSize"
    ></app-fb-input>
  </div>
</div>
